import React from 'react';

import BlackBox from 'Core/Components/BlackBox';
import ContentController from 'RLX/Controllers/ContentController';

class BlackBoxEditor extends ContentController {
  constructor (props) {
    super(props);
  }

  static getInitialShape () {
    return {
      props: {
        content: ''
      }
    };
  }

  getBlockName () {
    return 'Black Box';
  }

  getClassName () {
    return 'BlackBoxEditor';
  }

  getPreview () {
    return <BlackBox {...this.props.content.props} />
  }

  shouldDisplayPreviewInline () {
    return true;
  }

  getFields () {
    const { content } = this.props;

    const TEXTFIELD_MIN_ROWS = 4;
    const TEXTFIELD_MAX_ROWS = 15;
    const rowCount = Math.min(TEXTFIELD_MAX_ROWS, Math.max(TEXTFIELD_MIN_ROWS, Math.ceil(content.props.content.length / 50)));

    return [
      {
        type: 'code',
        icon: 'code',
        rows: rowCount,
        label: 'HTML Content',
        value: content.props.content,
        onChange: this.applyUpdate((content, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, content } };
        })
      },
      {
        type: 'select',
        className: 'text-lg',
        icon: 'paint-brush',
        label: 'Block Color',
        options: [
          { value: 'black', text: 'Black' },
          { value: 'yellow', text: 'Yellow' }
        ],
        value: content.props.color || 'black',
        onChange: this.applyUpdate((color, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, color } };
        })
      }
    ];
  };
};

export default BlackBoxEditor;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Editors/BlackBoxEditor.jsx